
// src/web/components/chat-album.jsx

import AlbumPage from './albumPage'
import connect from '../../connects/chat-album'

export default connect(AlbumPage)


// WEBPACK FOOTER //
// ./src/web/components/chat-album.jsx